import { errorMessage } from '../../../../error-message.js';
import { getSessionFileChangeDirectoryFlags } from '../../session-file-change-path-kind.js';
import { readGitHeadBlob, readUtf8WorkspaceFile } from '../../workspace-files.js';
import { editSnippetToUnifiedDiff } from '../../../../files/diff/unified-diff.js';
import type { FileDiffRecord } from '../extract-acp-file-diffs-from-update/index.js';
import type { SessionFileChangePayload } from './path-snapshot-tracker.js';

export function sendExtractedDiffsAsSessionFileChanges(
  diffs: FileDiffRecord[],
  send: (p: SessionFileChangePayload) => void,
  sessionParentPath: string,
  sessionId: string,
  runId: string,
  sentPaths: Set<string>,
  log: (msg: string) => void
): void {
  for (const d of diffs) {
    try {
      const patchContent = editSnippetToUnifiedDiff(d.path, d.oldText, d.newText);
      const dirFlags = getSessionFileChangeDirectoryFlags(sessionParentPath, d.path);
      send({
        type: 'session_file_change',
        sessionId,
        runId,
        path: d.path,
        oldText: d.oldText,
        newText: d.newText,
        patchContent,
        isDirectory: dirFlags.isDirectory,
        directoryRemoved: dirFlags.directoryRemoved,
      });
      sentPaths.add(d.path);
    } catch (err) {
      log(`[Bridge service] Session file change failed for ${d.path}: ${errorMessage(err)}`);
    }
  }
}

export function sendGitHeadVsWorkspaceForToolPaths(
  mergedPaths: string[],
  sentPaths: Set<string>,
  send: (p: SessionFileChangePayload) => void,
  sessionParentPath: string,
  sessionId: string,
  runId: string,
  log: (msg: string) => void
): void {
  for (const displayPath of mergedPaths) {
    if (sentPaths.has(displayPath)) continue;
    const oldText = readGitHeadBlob(sessionParentPath, displayPath);
    const newText = readUtf8WorkspaceFile(sessionParentPath, displayPath);
    if (oldText === newText) continue;
    try {
      const patchContent = editSnippetToUnifiedDiff(displayPath, oldText, newText);
      const dirFlags = getSessionFileChangeDirectoryFlags(sessionParentPath, displayPath);
      send({
        type: 'session_file_change',
        sessionId,
        runId,
        path: displayPath,
        oldText,
        newText,
        patchContent,
        isDirectory: dirFlags.isDirectory,
        directoryRemoved: dirFlags.directoryRemoved,
      });
      sentPaths.add(displayPath);
    } catch (err) {
      log(`[Bridge service] Session file change failed for ${displayPath}: ${errorMessage(err)}`);
    }
  }
}
